import React from 'react';
import './LegalPage.css';

function renderTable(table) {
    const hasHead = Boolean(table.head);
    return (
        <div className="legal-table-wrap">
            <table className="legal-table">
                {hasHead && (
                    <thead>
                        <tr>
                            {table.head.map((cell) => (
                                <th key={cell}>{cell}</th>
                            ))}
                        </tr>
                    </thead>
                )}
                <tbody>
                    {table.rows.map((row) => (
                        <tr key={row.join('|')}>
                            {row.map((cell, cellIndex) =>
                                !hasHead && cellIndex === 0 ? (
                                    <th scope="row" key={cell}>{cell}</th>
                                ) : (
                                    <td key={cell}>{cell}</td>
                                )
                            )}
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
}

function LegalPage({ eyebrow, title, intro, sections, footnote }) {
    const numbered = sections.filter((section) => !section.unnumbered);

    return (
        <div className="legal-page">
            <header className="legal-hero">
                {eyebrow && <span className="legal-eyebrow">{eyebrow}</span>}
                <h1>{title}</h1>
                {intro && <p className="legal-intro">{intro}</p>}
            </header>

            <main className="legal-content">
                {sections.map((section) => (
                    <section className="legal-card" key={section.title}>
                        {!section.unnumbered && (
                            <div className="legal-number">{numbered.indexOf(section) + 1}</div>
                        )}
                        <div className="legal-body">
                            <h2>{section.title}</h2>
                            {section.text && <p>{section.text}</p>}
                            {section.items && (
                                <ul>
                                    {section.items.map((item) => (
                                        <li key={item}>{item}</li>
                                    ))}
                                </ul>
                            )}
                            {section.table && renderTable(section.table)}
                        </div>
                    </section>
                ))}
            </main>

            {footnote && (
                <footer className="legal-footer">
                    <p>{footnote}</p>
                </footer>
            )}
        </div>
    );
}

export default LegalPage;
